import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import ArrowIcon from 'core/components/icons/ArrowIcon'

const RelatedProjectItem = ({ item }) => {
  return (
    <li className="related-projects-item">
      <Link to={`/project/${item.post_name}`} className="related-projects-item-link">
        <div
          className="related-projects-item-poster"
          style={{ backgroundImage: `url(${item.featured_image.medium_large[0]})` }}
        >
          <div className="related-projects-item-poster-hover">
            <ArrowIcon />
          </div>
        </div>
        <h3 className="related-projects-item-title">{item.post_title}</h3>
      </Link>
    </li>
  )
}

RelatedProjectItem.propTypes = {
  item: PropTypes.object.isRequired
}

export default RelatedProjectItem
